import React, { useState } from 'react';
import Header from '../partials/Header';
import Sidebar from '../partials/Sidebar';
import FintechCard01 from '../partials/fintech/FintechCard01';
import FintechCard02 from '../partials/fintech/FintechCard02';
import FintechCard03 from '../partials/fintech/FintechCard03';
import FintechCard04 from '../partials/fintech/FintechCard04';
import FintechCard05 from '../partials/fintech/FintechCard05';
import FintechCard06 from '../partials/fintech/FintechCard06';
import FintechCard07 from '../partials/fintech/FintechCard07';
import FintechCard08 from '../partials/fintech/FintechCard08';
import FintechCard09 from '../partials/fintech/FintechCard09';
import FintechCard10 from '../partials/fintech/FintechCard10';
import FintechCard11 from '../partials/fintech/FintechCard11';
import FintechCard12 from '../partials/fintech/FintechCard12';
import FintechCard13 from '../partials/fintech/FintechCard13';
import FintechCard14 from '../partials/fintech/FintechCard14';
import FintechCard15 from '../partials/fintech/FintechCard15';
import FintechCard16 from '../partials/fintech/FintechCard16';
import FintechCard17 from '../partials/fintech/FintechCard17';
import FintechCard18 from '../partials/fintech/FintechCard18';
import FintechCard19 from '../partials/fintech/FintechCard19';
import FintechCard20 from '../partials/fintech/FintechCard20';
import FintechCard21 from '../partials/fintech/FintechCard21';
import FintechCard22 from '../partials/fintech/FintechCard22';
import FintechCard23 from '../partials/fintech/FintechCard23';
import FintechCard24 from '../partials/fintech/FintechCard24';
import FintechCard25 from '../partials/fintech/FintechCard25';
import FintechCard26 from '../partials/fintech/FintechCard26';
import FintechCard27 from '../partials/fintech/FintechCard27';
import FintechCard28 from '../partials/fintech/FintechCard28';
import FintechCard29 from '../partials/fintech/FintechCard29';
import FintechCard30 from '../partials/fintech/FintechCard30';
import FintechCard31 from '../partials/fintech/FintechCard31';
import FintechCard32 from '../partials/fintech/FintechCard32';
import FintechCard33 from '../partials/fintech/FintechCard33';
import FintechCard34 from '../partials/fintech/FintechCard34';
import FintechCard35 from '../partials/fintech/FintechCard35';
import FintechCard36 from '../partials/fintech/FintechCard36';
import FintechCard37 from '../partials/fintech/FintechCard37';
import FintechCard38 from '../partials/fintech/FintechCard38';
import FintechCard39 from '../partials/fintech/FintechCard39';
import FintechCard40 from '../partials/fintech/FintechCard40';
import FintechCard41 from '../partials/fintech/FintechCard41';
import FintechCard42 from '../partials/fintech/FintechCard42';
import FintechCard43 from '../partials/fintech/FintechCard43';
import FintechCard44 from '../partials/fintech/FintechCard44';
import FintechCard45 from '../partials/fintech/FintechCard45';
import FintechCard46 from '../partials/fintech/FintechCard46';
import FintechCard47 from '../partials/fintech/FintechCard47';
import FintechCard48 from '../partials/fintech/FintechCard48';
import FintechCard49 from '../partials/fintech/FintechCard49';
import FintechCard50 from '../partials/fintech/FintechCard50';
import FintechCard51 from '../partials/fintech/FintechCard51';
import FintechCard52 from '../partials/fintech/FintechCard52';
import FintechCard53 from '../partials/fintech/FintechCard53';
import FintechCard54 from '../partials/fintech/FintechCard54';
import FintechCard55 from '../partials/fintech/FintechCard55';
import FintechCard56 from '../partials/fintech/FintechCard56';
import FintechCard57 from '../partials/fintech/FintechCard57';
import FintechCard58 from '../partials/fintech/FintechCard58';
import FintechCard59 from '../partials/fintech/FintechCard59';
import FintechCard60 from '../partials/fintech/FintechCard60';
import FintechCard61 from '../partials/fintech/FintechCard61';
import FintechCard62 from '../partials/fintech/FintechCard62';
import FintechCard63 from '../partials/fintech/FintechCard63';
import FintechCard64 from '../partials/fintech/FintechCard64';
import PaginationClassic from '../components/PaginationClassic';

const sections = [
  {
    title: '♻️ Bæredygtighed',
    content: [
      <FintechCard01 key="1" />,
      <FintechCard02 key="2" />,
      <FintechCard03 key="3" />,
      <FintechCard04 key="4" />,
      <FintechCard05 key="5" />,
      <FintechCard06 key="6" />,
      <FintechCard07 key="7" />,
    ],
  },
  {
    title: '🚙 Elbiler',
    content: [
      <FintechCard08 key="1" />,
    ],
  },
  {
    title: '🛍️ E-commerce',
    content: [
      <FintechCard09 key="1" />,
      <FintechCard10 key="2" />,
      <FintechCard11 key="3" />,
      <FintechCard12 key="4" />,
    ],
  },
  {
    title: '🪖 Forsvar',
    content: [
      <FintechCard13 key="1" />,
      <FintechCard14 key="2" />,
      <FintechCard15 key="3" />,
    ],
  },
  {
    title: '🕹️ E-sport & gaming',
    content: [
      <FintechCard16 key="1" />,
      <FintechCard17 key="2" />,
    ],
  },
  {
    title: '🔔 Børsnoteret for nylig',
    content: [
      <FintechCard18 key="1" />,
      <FintechCard19 key="2" />,
      <FintechCard20 key="3" />,
    ],
  },
  {
    title: '💰 Finans',
    content: [
      <FintechCard21 key="1" />,
      <FintechCard22 key="2" />,
      <FintechCard23 key="3" />,
      <FintechCard24 key="4" />,
    ],
  },
  {
    title: '📟 Banebrydende teknologi',
    content: [
      <FintechCard25 key="1" />,
      <FintechCard26 key="2" />,
      <FintechCard27 key="3" />,
      <FintechCard28 key="4" />,
      <FintechCard29 key="5" />,
      <FintechCard30 key="6" />,
      <FintechCard31 key="7" />,
      <FintechCard32 key="8" />,
      <FintechCard33 key="9" />,
    ],
  },
  {
    title: '💎 Råvarer',
    content: [
      <FintechCard34 key="1" />,
      <FintechCard35 key="2" />,
      <FintechCard36 key="3" />,
    ],
  },
  {
    title: '💃 Ligestilling',
    content: [
      <FintechCard37 key="1" />,
      <FintechCard38 key="2" />,
      <FintechCard39 key="3" />,
    ],
  },
  {
    title: '👔 Mode',
    content: [
      <FintechCard40 key="1" />,
      <FintechCard41 key="2" />,
      <FintechCard42 key="3" />,
      <FintechCard43 key="4" />,
    ],
  },
  {
    title: '🏥 Sundhed',
    content: [
      <FintechCard44 key="1" />,
      <FintechCard45 key="2" />,
    ],
  },
  {
    title: '🏡 Ejendomme',
    content: [
      <FintechCard48 key="1" />,
      <FintechCard49 key="2" />,
      <FintechCard03 key="3" />,
    ],
  },
  {
    title: '🍿 Underholdning',
    content: [
      <FintechCard46 key="1" />,
      <FintechCard47 key="2" />,
    ],
  },
  {
    title: '🍔 Mad & drikke',
    content: [
      <FintechCard01 key="1" />,
      <FintechCard50 key="2" />,
      <FintechCard51 key="3" />,
    ],
  },
  {
    title: '🌳 Natur',
    content: [
      <FintechCard52 key="1" />,
      <FintechCard53 key="2" />,
      <FintechCard54 key="3" />,
    ],
  },
  {
    title: '🌱 Grøn omstilling',
    content: [
      <FintechCard05 key="1" />,
      <FintechCard55 key="2" />,
      <FintechCard56 key="3" />,
    ],
  },
  {
    title: '⭐️ Kendte investorer',
    content: [
      <FintechCard57 key="1" />,
      <FintechCard58 key="2" />,
      <FintechCard59 key="3" />,
      <FintechCard60 key="4" />,
    ],
  },
  {
    title: '✈️ Rejser',
    content: [
      <FintechCard61 key="1" />,
      <FintechCard62 key="2" />,
      <FintechCard54 key="3" />,
    ],
  },
  {
    title: '⚽️ Sport & betting',
    content: [
      <FintechCard63 key="1" />,
      <FintechCard64 key="2" />,
    ],
  },
  {
    title: '⚡️ Energi',
    content: [
      <FintechCard05 key="1" />,
      <FintechCard55 key="2" />,
      <FintechCard56 key="3" />,
      <FintechCard34 key="4" />,
    ],
  },
];

const Fintech = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const sectionsPerPage = 3;

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleNavClick = (index) => {
    const targetPage = Math.floor(index / sectionsPerPage) + 1;
    setCurrentPage(targetPage);

    setTimeout(() => {
      const element = document.getElementById(sections[index].title);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  const startIndex = (currentPage - 1) * sectionsPerPage;
  const endIndex = startIndex + sectionsPerPage;
  const currentSections = sections.slice(startIndex, endIndex);

  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

      <div className="relative flex flex-1 overflow-hidden">
        <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
          <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

          <main className="grow">
            <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto flex">
              <div className="flex-1 pr-4">
                <div className="sm:flex sm:justify-between sm:items-center mb-5">
                  <div className="mb-4 sm:mb-0">
                    <h1 className="text-2xl md:text-3xl text-gray-800 dark:text-gray-100 font-bold">
                      Inspirationsliste
                    </h1>
                    <hr className="mt-2 border-gray-300 dark:border-gray-700" />
                  </div>
                </div>

                {currentSections.map((section, index) => (
                  <div key={index} className="mb-8" id={section.title}>
                    <h2 className="text-xl md:text-2xl text-gray-800 dark:text-gray-100 font-semibold mb-4">
                      {section.title}
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                      {section.content.map((card, cardIndex) => (
                        <div key={cardIndex} className="col-span-1">
                          {card}
                        </div>
                      ))}
                    </div>
                  </div>
                ))}

                <PaginationClassic
                  currentPage={currentPage}
                  totalPages={Math.ceil(sections.length / sectionsPerPage)}
                  onPageChange={handlePageChange}
                />
              </div>

              <div className="hidden lg:block w-64 flex-shrink-0 border-l border-gray-200 dark:border-gray-700 pl-4">
                <div className="sticky top-16">
                  <h3 className="text-xs uppercase text-gray-500 dark:text-gray-400 font-semibold mb-3">
                    Kategorier
                  </h3>
                  <nav className="space-y-2">
                    {sections.map((section, index) => (
                      <button
                        key={index}
                        onClick={() => handleNavClick(index)}
                        className="block w-full text-left text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white text-sm"
                      >
                        {section.title}
                        <span className="text-gray-400 text-xs ml-1">
                          ({section.content.length})
                        </span>
                      </button>
                    ))}
                  </nav>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default Fintech;